/**
 * Containment boundary for browser-owned legacy persistence.
 *
 * Release-reachable compatibility screens still reference the old Firestore
 * and Storage-shaped helpers. They must never regain data authority while the
 * private command/read models are being completed. Every operation therefore
 * fails before accepting or resolving a collection, document, or object path.
 */

export class LegacyBrowserPersistenceError extends Error {
  constructor() {
    super("This legacy data operation requires the private authority service.");
    this.name = "LegacyBrowserPersistenceError";
    this.code = "private-authority-required";
  }
}

const failClosed = () => {
  throw new LegacyBrowserPersistenceError();
};

// Deliberate compatibility tombstone for legacy call signatures. It is never
// a Firebase handle; every operation below rejects before reading this value or
// resolving a caller-provided path.
export const db = null;

export const addDoc = failClosed;
export const collection = failClosed;
export const deleteDoc = failClosed;
export const deleteField = failClosed;
export const deleteObject = failClosed;
export const doc = failClosed;
export const getDoc = failClosed;
export const getDocs = failClosed;
export const getDownloadURL = failClosed;
export const getFirestore = failClosed;
export const getStorage = failClosed;
export const increment = failClosed;
export const limit = failClosed;
export const onSnapshot = failClosed;
export const orderBy = failClosed;
export const query = failClosed;
export const runTransaction = failClosed;
export const serverTimestamp = failClosed;
export const setDoc = failClosed;
export const startAfter = failClosed;
export const storageRef = failClosed;
export const updateDoc = failClosed;
export const uploadBytes = failClosed;
export const uploadBytesResumable = failClosed;
export const where = failClosed;
export const writeBatch = failClosed;
